import type { Asset, Project } from '@frameio/graphql-client/generated';
import type { QuickSearchAssetResultV2NlpFragment } from '../shared/gql/generated/QuickSearchAssetResultV2Nlp';

export const isNlpResult = (
  resultItem: any
): resultItem is QuickSearchAssetResultV2NlpFragment => {
  return 'nlpMatches' in resultItem;
};

export const isAssetItem = (
  __item: Asset | Project,
  resultType: 'AssetResult' | 'ProjectResult' | undefined
): __item is Asset => {
  return resultType === 'AssetResult';
};

export const isProjectItem = (
  __item: Asset | Project,
  resultType: 'AssetResult' | 'ProjectResult' | undefined
): __item is Project => {
  return resultType === 'ProjectResult';
};
